import { Outlet } from "react-router-dom";
import { FloatingBtn } from "../component/FloatingBtn";
import { isMobile } from "../utils/func";
import { useResponsiveMobile } from "../hooks/useResponsiveMobile";

const WithFloatingLayout = () => {
  const isMobile = useResponsiveMobile(900);
  return (
    <>
      <Outlet />
      {isMobile ? "" : <FloatingBtn />}
    </>
  );
};

export default WithFloatingLayout;
